import React from "react";
import { formatPrice } from "utils/utils";

const SummaryTotals = ({ summaryData, containerClass = "row row-cards my-3" }) => {
  const cards = [
    {
      title: "Total Transaksi (Gross)",
      value: formatPrice(Number(summaryData?.total_transaksi || 0)),
      color: "bg-primary",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-currency-dollar" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M16.7 8a3 3 0 0 0 -2.7 -2h-4a3 3 0 0 0 0 6h4a3 3 0 0 1 0 6h-4a3 3 0 0 1 -2.7 -2" />
          <path d="M12 3v3m0 12v3" />
        </svg>
      ),
      details: null,
    },
    {
      title: "Total Tax",
      value: formatPrice(Number(summaryData?.total_tax || 0)),
      color: "bg-red",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-receipt-tax" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <line x1="9" y1="14" x2="15" y2="8" />
          <circle cx="9.5" cy="8.5" r=".5" fill="currentColor" />
          <circle cx="14.5" cy="13.5" r=".5" fill="currentColor" />
          <path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16l-3 -2l-2 2l-2 -2l-2 -2l-3 2" />
        </svg>
      ),
      details: (
        <div className="mt-1 text-muted" style={{ fontSize: "11px", lineHeight: "1.2" }}>
          <div>Tax Produk (10%) : {formatPrice(Number(summaryData?.total_tax_product || 0))}</div>
          <div>Tax EDC (3%) : {formatPrice(Number(summaryData?.total_tax_payment_method || 0))}</div>
        </div>
      ),
    },
    {
      title: "Total Transaksi (Net)",
      value: formatPrice(Number(summaryData?.total_transaksi_plus_tax || 0)),
      color: "bg-green",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-wallet" width="24" height="24" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12" />
          <path d="M20 12v4h-4a2 2 0 0 1 0 -4h4" />
        </svg>
      ),
      details: null,
    },
  ];

  return (
    <div className={containerClass}>
      {cards.map((card, index) => (
        <div className="col-sm-6 col-lg-4" key={index}>
          <div className="card card-sm h-100">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-auto">
                  <span className={`${card.color} text-white avatar`}>
                    {card.icon}
                  </span>
                </div>
                <div className="col">
                  <div className="font-weight-medium">{card.title}</div>
                  <div className="text-muted">{card.value}</div>
                  {card.details}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SummaryTotals;
